import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';

const UploadMLMAccountsPayments = () => {
  const [jsonData, setJsonData] = useState(null);
  const [error, setError] = useState('');

  // Validate each record against the schema definition
  const validateData = (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return 'Uploaded JSON is either empty or not in an array format.';
    }

    for (let i = 0; i < data.length; i++) {
        const record = data[i];
        
        // Validate required fields and data types
        if (!record.userId || typeof record.userId !== 'object' || !('$oid' in record.userId)) return `Record ${i + 1}: userId is invalid.`;
        if (!record.userCode || typeof record.userCode !== 'string') return `Record ${i + 1}: userCode is invalid.`;
        if (!record.userName || typeof record.userName !== 'string') return `Record ${i + 1}: userName is invalid.`;
        if (typeof record.amount !== 'number') return `Record ${i + 1}: amount must be a number.`;
        if (!record.date || typeof record.date !== 'object' || !('$date' in record.date)) return `Record ${i + 1}: date is invalid.`;
        if (!record.period || typeof record.period !== 'string') return `Record ${i + 1}: period must be a string.`;
        if (typeof record.isAdvice !== 'boolean') return `Record ${i + 1}: isAdvice must be a boolean.`;
        if (typeof record.isPayment !== 'boolean') return `Record ${i + 1}: isPayment must be a boolean.`;
        if (!record.createdBy || typeof record.createdBy !== 'object' || !('$oid' in record.createdBy)) return `Record ${i + 1}: createdBy is invalid.`;
        if (!record.paymentMode || typeof record.paymentMode !== 'string') return `Record ${i + 1}: paymentMode must be a string.`;
        if (!record.account || typeof record.account !== 'string') return `Record ${i + 1}: account must be a string.`;
        if (!record.paymentDetails || typeof record.paymentDetails !== 'string') return `Record ${i + 1}: paymentDetails must be a string.`;
        if (typeof record.isActive !== 'boolean') return `Record ${i + 1}: isActive must be a boolean.`;
        if (!record.companyRemarks || typeof record.companyRemarks !== 'string') return `Record ${i + 1}: companyRemarks must be a string.`;
        if (!record.userRemarks || typeof record.userRemarks !== 'string') return `Record ${i + 1}: userRemarks must be a string.`;
        if (!record.companyMessage || typeof record.companyMessage !== 'string') return `Record ${i + 1}: companyMessage must be a string.`;
        if (typeof record.isAccepted !== 'boolean') return `Record ${i + 1}: isAccepted must be a boolean.`;
        
        // Validate references for bookId and productId (if provided)
        if (record.bookId && (!record.bookId.$oid || typeof record.bookId.$oid !== 'string')) return `Record ${i + 1}: bookId is invalid.`;
        if (record.productId && (!record.productId.$oid || typeof record.productId.$oid !== 'string')) return `Record ${i + 1}: productId is invalid.`;
      }

    return ''; // No error found
  };

  // Handle file input change
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const parsedData = JSON.parse(event.target.result);
          const validationError = validateData(parsedData);
          if (validationError) {
            setError(validationError);
            setJsonData(null);
          } else {
            setJsonData(parsedData);
            setError('');
          }
        } catch (err) {
          setError('Invalid JSON format.');
          setJsonData(null);
        }
      };
      reader.readAsText(file);
    }
  };

  // Submit the JSON data to the backend
  const handleSubmit = async () => {
    if (!jsonData) {
      setError('No valid JSON data to submit.');
      return;
    }
    // console.log('Data to be submitted:', JSON.stringify(jsonData, null, 2));
    try {
      const response = await fetch('/mlmaccounts/paymentsupload', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(jsonData),
      });

      if (response.ok) {
        alert('Data uploaded successfully.');
        setJsonData(null); // Reset after successful upload
      } else {
        setError('Failed to upload data.');
      }
    } catch (error) {
      setError('Error uploading data: ' + error.message);
    }
  };

  return (
    <MainLayout>
        <div>
          <h3 className='text-lg mx-2 border-b border-b-gray-300 text-white'>MLM Payments Advice Upload</h3>
        </div>
        <div className="px-4 py-4 upload-seed-data-container text-white">
          <div className='flex flex-col ml-4 mr-4'>
            <h1 className="text-xl text-green-400 font-bold mb-4">Select and Upload Payment Data (JSON) </h1>
            <input type="file" accept=".json" onChange={handleFileUpload} className="mb-4" />

            {error && <div className="text-red-500 mb-4">{error}</div>}

            {jsonData && !error && (
              <div>
                <h2 className="text-green-500">JSON validated successfully. Ready to upload.</h2>
                <button onClick={handleSubmit} className="bg-blue-500 text-white px-4 py-2 mt-4">
                  Upload Payment Data
                </button>
              </div>
            )}
          </div>
        </div>
      </MainLayout>
  );
};

export default UploadMLMAccountsPayments;
